import { useRbac } from "@its-engineering-and-development/rbac-react";
import type { ActionKey } from "@/auth/permission-actions";
import { useAppSelector } from "@/store";
import { selectAllowedActions } from "@/store/permissions.slice";

export function useCan(action: ActionKey): boolean {
    return useAppSelector(selectAllowedActions).includes(action);
}

export type AccessStatus = "loading" | "resolved" | "error";

/**
 * Exposes the RBAC resolution status so route guards can show a loader while
 * permissions are being fetched instead of flashing the forbidden screen.
 */
export function useAccessStatus(): AccessStatus {
    return useRbac().status;
}
